import {Component, Injector, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Share} from '@capacitor/share';
import {ControllerComponent} from '../../Controller/controller-component';
import {OrdersApiService} from '../../../Services/Api/Purchases/Orders/orders-api.service';
import {OrderStatusEnum} from '../../../Shared/Enum/order-status.enum';
import {ApiStatusEnum} from '../../../Shared/Enum/api-status.enum';
import {OrderDto} from '../../../Models/Purchases/Orders/order.interface';
import {LinesDto} from '../../../Models/Purchases/Shared/line.interface';

@Component({
  selector: 'app-assistant-purchase-order',
  templateUrl: './assistant-purchase-order.component.html',
  styleUrls: ['./assistant-purchase-order.component.scss'],
  standalone: false,
})
export class AssistantPurchaseOrderComponent extends ControllerComponent implements OnChanges {

  @Input() orderId!: number;

  order: OrderDto | null = null;

  isLoadingOrder: boolean = true;
  isCreatingOrder: boolean = false;

  get linesCount(): number {
    return this.order?.lineas?.length || 0;
  }

  get isCreated(): boolean {
    return this.order?.id_estado === OrderStatusEnum.sent;
  }

  constructor(
    protected override injector: Injector,
    protected ordersService: OrdersApiService,
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['orderId'] && this.orderId) {
      this.loadOrder();
    }

  }


  /**
   * Guardar la cantidad de una línea
   *
   */
  saveLineQuantity(line: LinesDto) {
    this.ordersService.saveLineQuantity({id: line.id, cantidad: line.cantidad});
  }


  /**
   * Crear el pedido (enviarlo al proveedor)
   *
   */
  createOrder() {

    if (!this.order || this.isCreatingOrder || this.isCreated) {
      return;
    }

    this.isCreatingOrder = true;

    this.ordersService.createOrderFromAssistant(this.order.id).then((response) => {

      if (response.status !== ApiStatusEnum.success) {
        this.toastCtrl.showSuccessToast(this.translate.instant('ASSISTANT.PURCHASE_ORDER.TOASTS.ERROR'));
        return;
      }

      this.order!.id_estado = OrderStatusEnum.sent;

    }).finally(() => {
      this.isCreatingOrder = false;
    });
  }


  /**
   * Compartir el pedido
   *
   */
  async shareOrder() {

    if (!this.order) {
      return;
    }

    const shareOptions = {
      title: this.translate.instant('PURCHASES.ORDERS.SHARE.TITLE', {ref: this.order.ref, local: this.order.local}),
      text: this.translate.instant('PURCHASES.ORDERS.SHARE.TEXT', {local: this.order.local}),
      url: this.order.url,
      dialogTitle: this.translate.instant('PURCHASES.ORDERS.SHARE.DIALOG_TITLE'),
    };

    await Share.share(shareOptions).catch(() => {
      console.error('Error: Share Api not implemented on web.');
    });
  }


  /**
   * Cargar el pedido
   *
   */
  loadOrder() {
    this.isLoadingOrder = true;

    this.ordersService.getOrder({id: this.orderId, new_function: 1}).then((response) => {

      if (response.status !== 1) {
        return;
      }

      this.order = response.data;

    }).finally(() => {
      this.isLoadingOrder = false;
    });
  }

}
